import React from 'react';

import { Link } from "react-router-dom";
import Avatar from "react-avatar";
import {i18n} from "translate/i18n";
import {useUser} from "store/providers/app";
import {getProfile} from "../../utils";

function Profile() {

    const { logout, user } = useUser()

    const handleLogout = () => {
        logout()
    }

    return (
        <>
            <li className="nav-item dropdown">
                <Link to="#" className="nav-link pt-1 pb-0" id="navbarDropdown" role="button"
                      data-bs-toggle="dropdown" aria-expanded="false">
                    <div className="d-flex position-relative mb-0 pb-0" style={{height: "40px"}}>
                    <span className="mt-1 pe-2">
                        <Avatar name={user?.username} round={true} size={30} />
                    </span>
                    </div>
                </Link>

                <ul className="dropdown-menu dropdown-menu-end pt-0 pb-0 me-1 mt-3 border-0 shadow-sm animate slideIn" aria-labelledby="navbarDropdown">
                    <li className="pt-2 pb-2 px-3">
                        <div className="d-flex position-relative pb-0">
                        <span className="mt-2 pe-3">
                            <Avatar name={user?.username} round={true} size={50}/>
                        </span>
                            <div className="mt-1">
                                <h5 className="fw-normal mb-0">
                                    {user?.username}
                                </h5>
                                <p className="text-muted fw-light text-sm mb-0">{user?.email}</p>
                                <p className="text-sm fw-bolder mb-0">{ getProfile(user?.profile) }</p>
                            </div>
                        </div>
                    </li>
                    <hr className="dropdown-divider bg-light mx-2 my-0"/>
                    <li>
                        <button className="btn dropdown-item rounded-0 rounded-bottom" type="button" onClick={ handleLogout }>
                            <p className="m-2 text-center">
                                <i className="bi bi-box-arrow-in-right text-theme mr-1"/> {i18n.t('buttons.logout')}
                            </p>
                        </button>
                    </li>
                </ul>
            </li>
        </>
    );
}

export default Profile
